import { Heading } from "@afa-shared/afa-components";
import clsx from "clsx";

import colorPaletteStyles from "./ColorPalette.module.css";
import { IColor, IColors, IColorsSettings, getColorPalette } from "./ColorPaletteHelper";

export interface IColorPaletteProps {
  palette:
    | "primary"
    | "secondary"
    | "complementary"
    | "blackAndWhite"
    | "extendedIllustrations"
    | "extendedInfoGraphic"
    | "contrasts";
  heading: string;
  children: any;
  className?: string;
}

const ColorPalette = ({
  palette,
  heading,
  children,
  className,
}: IColorPaletteProps): React.ReactElement => {
  const colorPalette = getColorPalette(palette);

  return (
    <div className={clsx(colorPaletteStyles.colorPalette, className)}>
      {heading && <Heading variant="h2">{heading}</Heading>}
      {children && <div className={colorPaletteStyles.description}>{children}</div>}
      {colorPalette?.colors && (
        <ul
          className={clsx(colorPaletteStyles.palettesWrapper, {
            [colorPaletteStyles.multiColor]: palette !== "primary",
          })}
        >
          {colorPalette?.colors?.map((color: IColor, index: number) => {
            return (
              <li key={index}>
                <div
                  className={clsx(colorPaletteStyles.colorPreview, {
                    [colorPaletteStyles.primary]: palette === "primary",
                    [colorPaletteStyles.border]: color?.colorName === "White",
                  })}
                  style={{ background: color?.settings["hex"] }}
                />
                <div>
                  <span className={colorPaletteStyles.colorLabel}>{color.colorName}</span>
                  <ul className={colorPaletteStyles.colorSettings}>
                    {Object.keys(color?.settings).map((key: string, index: number) => {
                      return (
                        <li className={colorPaletteStyles.colorSetting} key={index}>
                          <span className={colorPaletteStyles.settingLabel}>
                            {key?.toUpperCase()}
                          </span>
                          <span className={colorPaletteStyles.setting}>{color?.settings[key]}</span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </li>
            );
          })}
        </ul>
      )}
      {colorPalette?.colorSection && palette === "contrasts" && (
        <ul className={colorPaletteStyles.colorContrastWrapper}>
          {colorPalette?.colorSection?.map((section: IColors, index: number) =>
            section.colors?.map((settings: IColorsSettings, colorIndex: number) => {
              const colorSection = `section-${index}`;
              return (
                <li
                  className={clsx(colorPaletteStyles.colorBase, colorSection)}
                  style={{ background: settings?.baseColorHex }}
                  key={colorIndex}
                >
                  <div
                    className={colorPaletteStyles.textContainer}
                    style={{ color: settings.topColorHex }}
                  >
                    <span>{settings?.wcagStandard}</span>
                    <span>{settings?.topColorName}</span>
                    <span>mot</span>
                    <span>{settings?.baseColorName}</span>
                  </div>
                </li>
              );
            }),
          )}
        </ul>
      )}
    </div>
  );
};

export default ColorPalette;
